import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const clusterSummarySchema = z.object({
  _id: zExt.objectId(),
  title: z.string(),
  description: z.string(),
  canonicalUserProblem: z.string(),
  product: z.string().optional(),
  requestCount: z.number(),
  uniqueCompanies: z.array(z.string()),
  complexity: z.enum(["trivial", "small", "medium", "large", "xl"]).optional(),
  estimatedLines: z.number().nullable(),
  priorityScore: z.number(),
  status: z.enum(["pending", "approved", "rejected", "deferred", "shipped"]),
  linearTicketId: z.string().nullable(),
  linearTicketUrl: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const getReviewQueue = {
  name: "getReviewQueue" as const,
  input: z.object({
    status: z
      .array(z.enum(["pending", "approved", "rejected", "deferred", "shipped"]))
      .optional(),
    search: z.string().optional(),
    sortBy: z.enum(["priorityScore", "requestCount", "createdAt"]).optional(),
    sortOrder: z.enum(["asc", "desc"]).optional(),
    page: z.number().int().positive().optional(),
    pageSize: z.number().int().positive().optional(),
  }),
  output: z.object({
    clusters: z.array(clusterSummarySchema),
    totalCount: z.number(),
  }),
};
